<div [ngClass]="{ hidden: !isReadyToShow }">
  <!-- ▼ ▼ ▼ プランヘッダエリア ▼ ▼ ▼ -->
  <ng-container *ngIf="!isUnsaved || isPlanChanged || !isPlanValid">
    <asw-plan-review-plan-header-area
      [isUnsaved]="isUnsaved"
      [isPlanChanged]="isPlanChanged"
      [isPlanValid]="isPlanValid"
      [planHeaderAreaData]="planHeaderAreaData"
    ></asw-plan-review-plan-header-area>
  </ng-container>

  <!-- [コンテンツ領域] -->
  <div class="l-core-contents">
    <div class="l-wrap">
      <div class="l-wrap__inner">
        <!-- [コンテンツ領域2カラム] -->
        <!--
          /=====================================================
          サブカラムがない場合は.l-core-contents__innerに
          クラス名l-core-contents__inner--full」を追加付与でフルカラムになります
          =====================================================/
        -->
        <div
          class="l-core-contents__tabpanel is-current"
          id="panel-1"
          role="tabpanel"
          aria-labelledby="tab1"
          tabindex="0"
        >
          <div class="l-core-contents__inner delete-padding-bottom">
            <!-- [コンテンツ領域2カラム−メイン] -->
            <div class="l-core-contents__main">
              <!-- ▼ ▼ ▼ 旅程部 ▼ ▼ ▼ -->
              <asw-trip-summary
                [masterData]="masterData"
                (readyToShow)="notifyReadyToShow('tripSummary')"
              ></asw-trip-summary>

              <!-- ▼ ▼ ▼ 運賃ルール ▼ ▼ ▼ -->
              <asw-plan-review-fare-conditions
                [isPlanValid]="isPlanValid"
                [fareCondsRes]="fareConditionsResponse"
              ></asw-plan-review-fare-conditions>

              <!-- ▼ ▼ ▼ 手荷物ルール ▼ ▼ ▼ -->
              <asw-plan-review-baggage-rules
                [isPlanValid]="isPlanValid"
                [fareCondsRes]="fareConditionsResponse"
              ></asw-plan-review-baggage-rules>

              <!-- ▼ ▼ ▼ 搭乗者人数エリア ▼ ▼ ▼ -->
              <asw-passenger-number-area></asw-passenger-number-area>

              <!-- ▼ ▼ ▼ サービスパーツ ▼ ▼ ▼ -->
              <asw-service-part
                [masterData]="masterData"
                (readyToShow)="notifyReadyToShow('serviceParts')"
              ></asw-service-part>
            </div>
            <!-- //[コンテンツ領域2カラム−メイン] -->

            <!-- [コンテンツ領域2カラム−サブ] -->
            <div class="l-core-contents__sub">
              <div class="p-sub-column-layout02 delete-padding-bottom">
                <!-- ▼ ▼ ▼ 積算マイル ▼ ▼ ▼ -->
                <asw-plan-review-accrual-miles
                  [isPlanValid]="isPlanValid"
                  [accrualMiles]="accrualMiles"
                ></asw-plan-review-accrual-miles>

                <!-- ▼ ▼ ▼ 支払情報サマリ ▼ ▼ ▼ -->
                <asw-payment-summary (readyToShow)="notifyReadyToShow('paymentSummary')"></asw-payment-summary>

                <div class="p-sub-column-layout02__body">
                  <div *ngIf="isPc" class="p-sub-column-layout02__body-item">
                    <!-- ▼ ▼ ▼ プラン操作メニュー ▼ ▼ ▼ -->
                    <asw-plan-manipulation-menu
                      [isUnsaved]="isUnsaved"
                      [isPlanValid]="isPlanValid"
                    ></asw-plan-manipulation-menu>
                  </div>
                </div>
              </div>
            </div>
            <!-- //[コンテンツ領域2カラム−サブ] -->
          </div>

          <div class="l-core-contents__main">
            <!-- [コンテンツ領域2カラム−メイン] #2 -->

            <!-- ▼ ▼ ▼ 搭乗者情報入力情報 ▼ ▼ ▼ -->
            <asw-passenger-info
              *ngIf="isTravelersInfoRegistered"
              [masterData]="masterData"
              [isNhAndArriveUsa]="isNhAndArriveUsa"
              (readyToShow)="notifyReadyToShow('passengerInfo')"
              (allPhoneReg)="setAllPhoneReg($event)"
              (allRepContactsReg)="setAllRepContactsReg($event)"
              (allPassengersReg)="setAllPassengersReg($event)"
            ></asw-passenger-info>

            <div
              class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56 l-section__open-passenger-info-input-modal-btn-wrapper"
            >
              <!-- ▼ ▼ ▼ 搭乗者情報入力モーダル表示ボタン ▼ ▼ ▼ -->
              <asw-button
                *ngIf="showContinueToBookBtn"
                id="plan-review-pres-component-open-pax-info-modal-btn"
                (click$)="openPassengerInformationInputModal()"
                [throttleClick]="true"
                [disabled]="!isPlanValid || !isAbleToOpenPassengerInfoRequest"
                [label]="'label.continueToBook' | staticMsg"
              ></asw-button>
            </div>

            <!-- ▼ ▼ ▼ プラン保存エリア ▼ ▼ ▼ -->
            <div *ngIf="isUnsaved && !(isApfLogin || isAnaBizLogin)" class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
              <asw-plan-review-plan-save-area
                [isPlanValid]="isPlanValid"
                [currentCart]="currentCart"
              ></asw-plan-review-plan-save-area>
            </div>
            <!-- ▲ ▲ ▲ プラン保存エリア ▲ ▲ ▲ -->

            <!-- ▼ ▼ ▼ 同意文言エリア ▼ ▼ ▼ -->
            <asw-agreement-area
              *ngIf="isAllPaxInfoRegistered || !isTravelersInfoRegistered"
              id="canada-agreement-area"
              [agreementAreaParts]="agreementAreaParams"
              (agreeStatusChange)="reflectCaAgreement($event)"
            ></asw-agreement-area>

            <!-- ▼ ▼ ▼ 現在時刻 ▼ ▼ ▼ -->
            <div class="l-section__current-date">
              {{ currentDate | dateFormat : 'default_currentDate' }}
            </div>

            <!-- //[コンテンツ領域2カラム−メイン] #2 -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- //[コンテンツ領域] -->
</div>

<!-- [画面下部固定フローティングナビ] -->
<ng-container
  *ngIf="
    isTravelersInfoRegistered &&
    allRepContactsReg &&
    allPassengersReg &&
    ((isNhAndArriveUsa && allPhoneReg) || !isNhAndArriveUsa) &&
    isReadyToShow
  "
>
  <asw-plan-review-footer [isAbleToGoToNextPage]="isAbleToGoToNextPage"></asw-plan-review-footer>
</ng-container>

<!-- ▼ ▼ ▼ criteo連携情報 ▼ ▼ ▼ -->
<ng-container *ngIf="isOutputCriteo">
  <asw-plan-review-criteo [totalAmount]="criteoTotalAmount"></asw-plan-review-criteo>
</ng-container>
